<!-- =========================================================================================
    File Name: ItemListView.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <vx-card class="list-view-item mb-base overflow-hidden">

    <template slot="no-body">
      <div class="vx-row item-details no-gutter">

        <!-- IMG COL -->
        <div class="vx-col sm:w-1/4 w-full item-img-container bg-white flex items-center justify-center">
          <img v-if="item.image"
               :src="item.image.src"
               :alt="item.title"
               style="width: 250px;height: 250px;"
               class="grid-view-img p-4 object-cover">
        </div>

        <!-- ITEM NAME & DESC COL -->
        <div class="vx-col sm:w-1/2">
          <div class="p-4 pt-6">
            <slot name="item-meta">
              <h6 class="item-name font-semibold mb-1">{{ item.name }}</h6>
              <p class="text-sm mb-4 cursor-pointer">By <span class="text-primary font-semibold">{{ item.brand }}</span>
              </p>
              <p class="item-description text-sm">{{ item.description }}</p>
            </slot>
          </div>
        </div>

        <!-- PURCHASE COL -->
        <div
          class="vx-col sm:w-1/4 w-full flex items-center border border-solid d-theme-border-grey-light border-r-0 border-t-0 border-b-0">

          <div class="p-4 flex flex-col w-full">
            <div class="my-6">
              <h5 class="font-bold text-center">
                <div v-if="item.coupon" style="color: green">
                  Discount: {{getDiscount()}} %
                </div>
                {{ getPrice(item) * item.qty | price }}
                <span></span>

              </h5>
              <span class="text-grey flex items-start justify-center mt-1" v-if="item.free_shipping">
                                <feather-icon icon="ShoppingCartIcon" svgClasses="w-4 h-4"/>
                                <span class="text-sm ltr:ml-2 rtl:mr-2">Free shipping</span>
                            </span>
            </div>

            <!-- SLOT: ACTION BUTTONS -->
            <slot name="action-buttons"/>
          </div>
        </div>
      </div>
    </template>

  </vx-card>
</template>

<script>
  export default {
    props: {
      item: {
        type: Object,
        required: true
      }
    },
    computed: {
      isInCart() {
        return (itemId) => this.$store.getters['eCommerce/isInCart'](itemId)
      },
      isInWishList() {
        return (itemId) => this.$store.getters['eCommerce/isInWishList'](itemId)
      },
      isLogin() {
        return localStorage.getItem('accessToken') != undefined;
      },

    },
    methods: {
      toggleItemInWishList(item) {
        this.$store.dispatch('eCommerce/toggleItemInWishList', item)
      },
      getDiscount() {
        let price = this.getOnlyPrice(this.item);
        if (this.item.coupon) {
          switch (this.item.couponType) {
            case 1:
              price = ((this.item.coupon / 100) * this.item.v.original_price);
              break;
            // case 2:;
            //   break;
            default:
              price = 0;
          }
        }
        return (price*100)/this.item.v.original_price;
      },
      additemInCart(item) {
        this.$store.dispatch('eCommerce/additemInCart', item)
      },
      getOnlyPrice(item) {
        let price;
        if (this.isLogin) {
          price = _.get(item, 'variants.0.price', 0);
          return  price;
        }
        price = _.get(item, 'variants.0.original_price', 0);
        return price;
      },

      getPrice(item) {
        let price = item.v.original_price;
        if (item.coupon) {
          switch (item.couponType) {
            case 1:
              price -= ((item.coupon / 100) * price);
              break;
            case 2:
              price -= item.coupon;
              break;
          }
        }
        if (price < 0) price = 0;
        return price;
      },
      cartButtonClicked(item) {
        this.isInCart(item.objectID) ? this.$router.push('/checkout').catch(() => {
        }) : this.additemInCart(item)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .list-view-item {
    .item-name, .item-description {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .item-name {
      -webkit-line-clamp: 2;
    }

    .item-description {
      -webkit-line-clamp: 5;
    }

    .grid-view-img {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      transition: .35s;
    }

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, .25);

      .grid-view-img {
        opacity: 0.9;
      }
    }
  }
</style>
